<section *ngIf="enabled">
  <ng-content></ng-content>
</section>
